import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress, Drawer, Box, Chip, Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../redux/store/appStore';
import { STATUS } from '../../utils/status';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { TableCellHead } from '../table/tableCell';
import { useStyles } from '../../assets/styles/listTableStyle';
import TableRowItem from './configTableRowItem';
import { getConfigData, getConfigForTable, setUpdateConfigStatus, updateConfig } from '../../redux/slices/config';
import DeleteModal from '../modal/deleteModal';
import Error from '../error/error';
import SnackbarNotification from '../snackbar/snackbarNotification';
import QuestionReportDrawer from './QuestionReportDrawer';
import { getReview } from '../../redux/slices/reviewerSlice';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import PaginationEntries from '../pagination/paginationEntries';
import ConfigTablePagination from './ConfigTablePagination';
import PermDataSettingIcon from '@mui/icons-material/PermDataSetting';
import ArrowButton from '../ArrowButton/arrowButton';
import { cloneProjectConfig } from '../../redux/slices/projectSlice/addProjectSlice';
import ProjectClonePopup from '../uploadTask/ProjectClonePopup';
import { setSelectedStageId } from '../../redux/slices/reviewerSlice/index';

interface ConfigInterface {
  onAddConfigClick?: any;
  selectedStage?: string;
}

const ConfigTable: React.FC<ConfigInterface> = () => {
  const classes = useStyles();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { id } = useParams();
  const path = window.location.href.includes('test')
  const isPathConfig = window.location.href.includes('config');
  // const [currentPage] = useState(1);
  // const [itemsPerPage] = useState<number>(50);
  const [searchTerm] = useState('');
  const [sortColumn] = useState('name');
  const [sortOrder] = useState('asc');
  const [loading, setLoading] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [userIdToDelete, setUserIdToDelete] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState<'success' | 'error' | 'info' | 'warning'>('success');
  const [drawer, setDrawer] = useState(false)
  const [selectedRow, setSelectedRow] = useState('');
  const getReviewStatus = useSelector((state: RootState) => state.reviewStage.getReviewStatus);
  const getReviewStages = useSelector((state: RootState) => state.reviewStage.reviewer);
  const [selectedStage, setSelectedStage] = useState<number | ''>('');
  const config = useSelector((state: RootState) => state.config.config);
  const getStatus = useSelector((state: RootState) => state.config.getConfigStatus);
  const updateStatus = useSelector((state: RootState) => state.config.updateStatus);
  const updateConfigMessage = useSelector((state: RootState) => state.config.updateConfigMessage);
  const [filterType, setFilterType] = useState('TASK');
  const [selectedChip, setSelectedChip] = useState<number | ''>('');
  const [open, setOpen] = React.useState(false);
  const [currentPage, setCurrentPage]: any = useState(1);
  const [itemsPerPage, setItemsPerPage]: any = useState<number>(10);
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [projectClonePopupOpen, setProjectClonePopupOpen] = useState(false);
  const [anchorE2, setAnchorE2] = useState(null);

  const selectedStageConfig = searchParams.get("selectedStageConfig");

  const paginate = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const cancelDelete = () => {
    setShowDeleteModal(false);
  };

  const handleSnackbar = (message: string, severity: 'success' | 'error' | 'info' | 'warning') => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };
  const handleDeleteClick = (userId: string) => {
    setUserIdToDelete(userId);
    setShowDeleteModal(true);
  };

  useEffect(() => {
    if (
      getReviewStages &&
      getReviewStages.results &&
      getReviewStages.results.length > 0
    ) {
      setSelectedChip(getReviewStages.results[0].id);
    }
  }, [getReviewStages]);

  useEffect(() => {
    if (updateStatus === STATUS.SUCESS) {
      handleSnackbar(updateConfigMessage, "success")
    }
    if (updateStatus === STATUS.FAILED) {
      handleSnackbar(updateConfigMessage, "error")
    }

    if (updateStatus === STATUS.SUCESS || updateStatus === STATUS.FAILED) {
      dispatch(setUpdateConfigStatus({}))
    }
  })

  useEffect(() => {
    if (selectedChip) {
      setSelectedStageId(selectedChip);
    }
  }, [dispatch, selectedChip]);

  const confirmDelete = async () => {
    setShowDeleteModal(false);
    try {
      await dispatch(updateConfig({ id: userIdToDelete, is_deleted: true }));
      dispatch(
        getConfigForTable({ pageSize: itemsPerPage, project_id: id || '', stage_id: selectedStage, ...(path && { type: 'TEST' }) })
      );
    } catch (error) {
      // console.error('Failed to delete config', error);
    }
  };




  useEffect(() => {
    dispatch(getReview({ project_id: id || '' }))
  }, [dispatch, id]);

  useEffect(() => {
    if (selectedStage) {
      dispatch(getConfigForTable({
        search: searchTerm, page: currentPage, pageSize: itemsPerPage, project_id: id || '', ...(path && { type: 'TEST' })
        , stage_id: selectedStage
      }))
    }
  }, [dispatch, searchTerm, currentPage, sortColumn, sortOrder, itemsPerPage, filterType, selectedStage, id]);


  const handleChipClick = (clickedChipId: number) => {
    dispatch(setSelectedStageId(clickedChipId));
    setSelectedChip(clickedChipId)
    setSelectedStage(clickedChipId)
  }

  useEffect(() => {
    if ( getReviewStages && getReviewStages.results && getReviewStages.results.length > 0) {
      if (selectedStageConfig) {
        const stageIdNumber = Number(selectedStageConfig);
        setSelectedStage(stageIdNumber);
        setSelectedChip(stageIdNumber);
        dispatch(setSelectedStageId(stageIdNumber));
      } else {
        const defaultStageId = getReviewStages.results[0].id;
        setSelectedStage(defaultStageId);
        setSelectedChip(defaultStageId);
        dispatch(setSelectedStageId(defaultStageId));
      }
    }
  }, [getReviewStages, selectedStageConfig, dispatch]);

  const handleAddClick = () => {
    path ? navigate(`/addtest/${id}`) : navigate(`/addconfig/${id}?selectedStageConfig=${selectedStage}`);
    dispatch(getConfigData({}));
  };
  const handleUploadBulkQuestionsClick = () => {
    navigate(`/uploadQuestions/${id}`)
  };

  const handleEditClick = async (row: any) => {
    console.log('Edit clicked for config:', row);
    console.log('Config name:', row.name);
    
    // Call API only for single_select
    if (row.name === 'single_select') {
      console.log('Fetching options for single_select config_id:', row.id);
      
      try {
        const token = document.cookie.split('; ').find(row => row.startsWith('token='))?.split('=')[1];
        const response = await fetch(`https://devapi.accunai.com/project/common/config_options/?config_id=${row.id}&value=`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        const result = await response.json();
        console.log('API Response for single_select options:', result);

        if (result.success && result.data) {
          console.log(`Successfully fetched ${result.data.length} options`);
        } else {
          console.log('No options found or API call failed');
        }
      } catch (error) {
        console.error('Error fetching config options:', error);
      }
    } else {
      console.log('Skipping API call - not a single_select config');
    }
    
    dispatch(getConfigData(row));
    path ? navigate(`/edittest/${id}/${row.config_details?.id}/${row.id}`) : navigate(`/editconfig/${id}/${row.config_details?.id}/${row.id}?selectedStageConfig=${selectedStage}`);
  };

  useEffect(() => {
    const handleGetStatus = () => {
      if (getStatus === STATUS.PENDING) {
        setLoading(true)
      }
      if (getStatus === STATUS.SUCESS) {
        setLoading(false)
      }
      if (getStatus === STATUS.FAILED) {
        setLoading(false)
      }
    };

    handleGetStatus();
  }, [getStatus])

  // const headers = [...(path ? (["ORDER", "DIFFICULTY LEVEL"]) : (["ORDER"])), path ? "CORRECT ANSWER" : "TYPE", "CONFIG TYPE", isPathConfig ? "REQUIRED" : undefined, "VALUE", ...!path ? ["CONFIG IDENTIFIER"] : [], "ACTIONS",];
  const headers = [
    ...(path ? ["DIFFICULTY LEVEL"] : ""),
    path ? "CORRECT ANSWER" : "TYPE",
    "CONFIG TYPE",
    ...(isPathConfig ? ["REQUIRED"] : []),
    "VALUE",
    ...(!path ? ["CONFIG IDENTIFIER"] : []),
    "ACTIONS"
  ];

  const handleChangeRowsPerPage = (value: number) => {
    setItemsPerPage(value as number);
    setCurrentPage(1);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleMenuClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleConfigCloneSubmit = (selectedProject: any) => {
    const payload = {
      target_project_id: id,
      source_project_id: selectedProject?.source_project_id,
      stage_mappings: selectedProject?.stage_mappings,
      type: path ? "test" : "config",
    };
    dispatch(cloneProjectConfig(payload));
  };

  const handleProjectCloneOpen = () => {
    setProjectClonePopupOpen(true);
    setAnchorE2(null);
    setAnchorEl(null);
  };

  const totalPages = Math.ceil((config.count || 0) / itemsPerPage);



  const guard: any = () => {
    handleSnackbar("Create stage first from Gigsource to add configs.", "error")
    return;
  }



  return (
    <>
      <Drawer
        anchor={"right"}
        open={drawer}
        onClose={() => setDrawer(false)}
        PaperProps={{ sx: { width: "60%", padding: "40px" } }}
      >
        <QuestionReportDrawer drawer={drawer} setDrawer={setDrawer} selectedRow={selectedRow} />
      </Drawer>


      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '20px' }}>
        <PaginationEntries itemsPerPage={itemsPerPage} onChangeRowsPerPage={handleChangeRowsPerPage} />
        {path ? (
          <>
            <Button
              variant="contained"
              disableElevation
              onClick={handleUploadBulkQuestionsClick}
              sx={{
                width: 'auto',
                height: '40px',
                marginTop: '10px',
                borderRadius: '8px 0 0 8px',
                padding: '8px, 16px, 8px, 16px',
                backgroundColor: '#3D85C6',
                textTransform: 'none',
                marginLeft: '10px',
                '&:hover': {
                  backgroundColor: '#3D85C6',
                },
              }}>
              <FileUploadOutlinedIcon fontSize='small' sx={{ marginRight: '10px' }} /> Upload Bulk Questions
            </Button>
            <ArrowButton handleMenuClick={handleMenuClick} anchorEl={anchorEl} handleMenuClose={handleMenuClose} handleAddClick={handleAddClick} menuText={"Add Question"} handleCloneTest={handleProjectCloneOpen} />

          </>
        ) : (
          <>

            <Button
              variant="contained"
              disableElevation
              onClick={(getReviewStages?.count ?? 0) <= 0 ? guard : handleAddClick}
              sx={{
                width: 'auto',
                height: '40px',
                marginTop: '10px',
                borderRadius: '8px 0 0 8px',
                padding: '8px 16px 8px 16px',
                backgroundColor: '#3D85C6',
                textTransform: 'none',
                marginLeft: '10px',
                '&:hover': {
                  backgroundColor: '#3D85C6',
                },
              }}>
              <PermDataSettingIcon fontSize='small' sx={{ marginRight: '10px' }} /> Add Config
            </Button>

            <ArrowButton
              handleMenuClick={(getReviewStages?.count ?? 0) <= 0 ? guard : handleMenuClick}
              anchorEl={anchorEl}
              handleMenuClose={handleMenuClose}
              handleAddClick={(getReviewStages?.count ?? 0) <= 0 ? guard : handleProjectCloneOpen}
              menuText={path ? "Add Question" : "Clone Config"}
              reviewStageCount={getReviewStages?.count}
              guard={guard}
            />

          </>
        )}

      </div>

      <div style={{ marginTop: "10px", marginLeft: "-7px" }}>

        {!path &&
          <Box sx={{ overflowX: 'auto', whiteSpace: 'nowrap', scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
            {getReviewStatus === STATUS.SUCESS &&
              getReviewStages && getReviewStages.results && getReviewStages.results.length > 0 &&
              getReviewStages?.results?.map((option: any) => {
                return (
                  <Chip key={option.id} label={option.name} sx={{
                    marginLeft: '5px', marginBottom: "5px", backgroundColor: selectedChip === option.id ? '#1976d2' : 'default',
                    color: selectedChip === option.id ? 'white' : 'default',
                    '&:hover': {
                      backgroundColor: selectedChip === option.id ? '#1565c0' : '#e0e0e0',
                    },
                  }} onClick={() => {
                    handleChipClick(option.id)
                    setFilterType('REVIEW')
                  }}
                  />
                )
              }
              )}
          </Box>
        }
      </div>
      <TableContainer>
        {loading && (
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
            <CircularProgress />
          </div>
        )}

        {!loading && (
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead sx={{ backgroundColor: '#F7F9FA', '&:first-child td, &:first-child th': { borderBottom: 0 } }}>
              {headers.map((header) => (
                <TableCellHead key={header}>{header}</TableCellHead>
              ))}
            </TableHead>
            <TableBody>
              {getReviewStages?.results?.length > 0 && getStatus === STATUS.SUCESS && config && config.results && config.results.length > 0 ? (
                config.results.map((row: any) => (
                  <TableRowItem
                    key={row.id}
                    row={row}
                    onEditClick={handleEditClick}
                    onDeleteClick={handleDeleteClick}
                    drawer={drawer}
                    setDrawer={setDrawer}
                    setSelectedRow={setSelectedRow}
                  />
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={8} className={classes.noUsersMessage}>
                    <Error message={path ? 'There are no questions added as of yet. You can add a question to see it here.' : 'There are no configs added as of yet. You can add a config to see it here.'} />
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        )}

      </TableContainer>
      <ConfigTablePagination
        currentPage={currentPage}
        totalPages={totalPages}
        paginate={paginate}
        itemsPerPage={itemsPerPage}
      />
      <DeleteModal
        open={showDeleteModal}
        onCancel={cancelDelete}
        onConfirm={confirmDelete}
      />
      <SnackbarNotification
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
      <ProjectClonePopup
        open={projectClonePopupOpen}
        setProjectClonePopupOpen={setProjectClonePopupOpen}
        onSubmit={handleConfigCloneSubmit}
        clonePopUpTitle={path ? "Test" : "Configs"}
      />
    </>
  );
};

export default ConfigTable;
